import React from 'react';
import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {DynamicPageServerSideProps} from '@/_application/core/types';
import {getBrandUrl} from '@/_application/core/utils/common';

/**
 * SmallBrandSwiperCategory - ISR Component (Mobile)
 *
 * Receives pre-fetched brands from server-side (ISR) via variables.initialData.categoryBrands
 * No client-side data fetching - pure SSR/ISR rendering
 */
export const SmallBrandSwiperCategory = ({variables}: {variables: DynamicPageServerSideProps['variables']}) => {
    // Use pre-fetched brands from ISR instead of client-side hook
    const categoryBrands = variables?.initialData?.categoryBrands ?? [];

    const validBrands = categoryBrands.filter(brand => brand?.url && brand.img);
    if (!validBrands.length) return null;

    return (
        <>
            <p className="ml-4 pt-3 text-sm font-bold text-primary">Thương hiệu</p>

            <div className="ml-4 mt-2 !h-[64px] pb-3">
                <Swiper slidesPerView={'auto'} spaceBetween={20}>
                    {validBrands.map(brand => {
                        if (!brand?.img || !brand.url) return null;
                        const brandUrl = getBrandUrl(brand.url);

                        return (
                            <SwiperSlide key={brand?.id} className={'!h-[64px] !max-w-[64px]'}>
                                <Link href={brandUrl}>
                                    <div className="flex h-full w-full items-center justify-center">
                                        <Image src={brand.img} alt="Brand" width={64} height={64} />
                                    </div>
                                </Link>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </>
    );
};
